import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
    
      <p class="text-center mb-5">(пьеса в 3 действиях)</p>


      <p class="mb-3 bold">Действующие лица:</p>

      <p class="mb-1">
        1. Благодеев – главный положительный герой. С айфоном, айпадом, ай…незнаюещёчем. Шарится в социальных сетях, пишет проекты, получает гранты.
      </p>
      <p class="mb-1">
        2. Злодеев – хакер, пранкер, лузер. Зловещая личность.
      </p>
      <p class="mb-1">
        3. Юля – простая активистка в футболке с надписью «Kiss кис». Богато одарённая натура [в смысле форм].
      </p>
      <p class="mb-1">
        4. Профессор – очень учёный учёный.
      </p>
      

      <p class="text-center mt-3 mb-1 bold">Действие 1.</p>
      <p class="text-center mb-3">(Благодеев и Юля)</p>

      <p class="mb-1">
        (Благодеев и Юля склонились над ноутбуком.)
      </p>

      <p class="mb-1">
        <span class="bold">Благодеев</span>: Юля, ты веришь, что мы создадим новый соцпроект, который осчастливит всех одноногих левшей в мире?
      </p>

      <p class="mb-1">
        <span class="bold">Юля</span>: Нет, я придумала лучше: мы устроим великий флешмоб. Каждый человек на Земле возьмёт на руки и поцелует кошку; и сразу оба они станут счастливыми! Мы осчастливим весь мир! А назовём мы этот проект: «Kiss кис»!
      </p>

      <p class="mb-1">
        <span class="bold">Благодеев</span>: Тогда я напишу ещё проект: кастрировать всех бродячих кошек, чтобы они не рожали бедных, несчастных бездомных котят. А назовём мы его в твою честь: «Кастр-Юля»! Ах, как я вдохновлён! Юля, а ты чувствуешь творческий энтузиазм?
      </p>

      <p class="mb-1">
        <span class="bold">Юля</span>: Ага…
      </p>

      <p class="mb-1">
        <span class="bold">Благодеев</span>: Знаешь, Юля, а когда-то я думал, что ты просто дура…
      </p>

      <p class="mb-1">
        <span class="bold">Юля</span>: Разве это мешает тем, кто любит … благодеев?
      </p>

      <p class="mb-1">
        <span class="bold">(Благодеев и Юля хором)</span>: Сейчас мы что-нибудь ТАКОЕ придумаем!
      </p>
      


      <p class="text-center mt-3 mb-1 bold">Действие 2.</p>
      <p class="text-center mb-3">(Те же и Злодеев)</p>


      
      <p class="mb-1">
        <span class="bold">Злодеев</span>:  Никогда! Сейчас я совершу неблаговидный поступок!
      </p>

      <p class="mb-1">
        <span class="bold">Юля</span>: Нет, ты не сделаешь этого! Ведь в глубине души ты белый и пушистый! Нужно только понять тебя!
      </p>

      <p class="mb-1">
        <span class="bold">Злодеев</span>: Точно! А пока я брошу работу и учёбу и уйду в разгул. 
        Буду посещать сомнительные места, заражусь СПИДом, и вы все будете меня жалеть и спасать.
      </p>

      <p class="mb-1">
        <span class="bold">Благодеев</span>: А я в это время займусь общественно полезными социальными проектами, чувствуя к этому естественную склонность.
      </p>

      


      <p class="text-center mt-3 mb-1 bold">Действие 3.</p>
      <p class="text-center mb-3">(Те же и Профессор)</p>

      <p class="mb-1">
        <span class="bold">Профессор</span>: Моя профессия – профессор. 
        Я люблю учить. 
        В детстве я любил учить детей. 
        Или любил детей… Или не любил… не помню. 
        А сейчас я старый, и люблю учить молодых. 
        Люблю говорить с ними… И вообще, люблю говорить… 
        Особенно о социальных явлениях. 
        Либерализм, вуайеризм, педоцентризм, эвгемеризм, керрелизм! Что за слова! 
        Каких прекрасных явлений полна наука!
        О, Благодеев! Ты опять со своими безумными проектами?
      </p>

      <p class="mb-1">
        <span class="bold">Благодеев</span>: Профессор, я уверен, что Вы поймёте меня!
      </p>

      <p class="mb-1">
        <span class="bold">Профессор</span>: Понять?!? 
        Да ты опять опровергаешь всю теорию шести рукопожатий! 
        Я не позволю тебе уничтожить главный труд моей жизни!
      </p>

      <p class="mb-1">
        <span class="bold">Благодеев</span>: Профессор, из-за Вас мы станем жертвами науки!
      </p>

      <p class="mb-1">
        <span class="bold">Профессор</span>: Становитесь! 
        А я буду почивать на лаврах и продолжать уродовать души молодых учёных! Я – мракобес и обскурант!
      </p>

      <p class="mb-1">
        <span class="bold">Благодеев</span>: Юля, давай потеряем надежду и уйдём отсюда. Выходи за меня замуж!
      </p>

      <p class="mb-1">
        <span class="bold">Юля</span>: Нет! Я выйду за Злодеева: ведь я такая богато одарённая натура, а он такой бедный! Я должна помочь ему.
      </p>

      <p class="mb-1">
        <span class="bold">Благодеев</span>: Но ты будешь страдать!
      </p>

      <p class="mb-1">
        <span class="bold">Юля</span>: Пусть! В пламени страданий моя душа очистится и воспарит ещё выше!
      </p>

      <p class="mb-1">
        <span class="bold">Злодеев</span>: Но я предам тебя!
      </p>

      <p class="mb-1">
        <span class="bold">Юля</span>: Давай! Покинь меня ради другой зоозащитницы!
      </p>

      <p class="mb-1">
        <span class="bold">Злодеев</span>: Не сейчас. Потом. Когда у тебя будет ребёнок. Или два…
      </p>


      <p class="mb-1">
        <span class="bold">Благодеев</span>: Нет, я не выдержу! Я его сейчас…
      </p>

      <p class="mb-1">
        <span class="bold">Злодеев</span>: Нет, ты не сможешь этого сделать, потому что обладаешь слишком высоким моральным обликом.
      </p>

      <p class="mb-1">
        <span class="bold">Благодеев</span>: В любом случае, тебе не место в науке!
      </p>

      <p class="mb-1">
        <span class="bold">Профессор</span>: О, наука! Вы, молодые, не понимаете её. 
        Вы занимаетесь вашими дурацкими проектами и презентациями, вместо того, чтобы слушать мои серьёзные доклады. 
        Вот 40 лет назад я написал доклад… и где ж он? 
        Бумага рассыпалась, текст стёрся… И из памяти стёрся… 
        А вообще-то я ещё хоть куда! 
        Вот только рассеянный немного… 
        Снова я потерял где-то свой авторитет… 
        Где его найти?
      </p>

      <p class="mb-1">
        <span class="bold">Юля</span>: О, как он страдает! Я сейчас же выйду за него замуж! 
        И стану глубоко несчастной супругой профессора… или пенсионера… или пенис…
      </p>

      <p class="mb-1">
        <span class="bold">Злодеев</span>: Юля, а вот по этой причине выходи лучше за меня!
      </p>

      <p class="mb-1">
        <span class="bold">Юля</span>: Нет, я не могу. Ведь я такая сложная, загадочная, многогранная натура!
      </p>
      
      <p class="mb-1">
        (поёт, танцует)
      </p>
      
      <p class="mb-1">
        <span class="bold">Благодеев</span>: Юля, я счастлив! Я люблю тебя!
      </p>

      <p class="mb-1">
        (поёт, танцует)
      </p>

      <p class="mb-1">
        <span class="bold">Злодеев</span>: О, как я морально повержен!
      </p>

      <p class="mb-1">
        (повергается в прах)
      </p>

      <p class="text-center mt-3 mb-3 bold">ЗАНАВЕС</p>
    

    </div>
    `
  )
}

const itemName = {
  rus: `Любовный квадрат`
}


const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;





